import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function SalaryComparatorPage() {
  return (
    <>
      <Header />
      <main style={{ padding: '4rem 5%', flex: 1 }}>
        <h1>Salary Comparator</h1>
        <p>This page is under construction.</p>
      </main>
      <Footer />
    </>
  );
}
